import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';

import { Button } from '../../../../components';
import cdaXsl from 'bundle-text:./cda.xsl';

class CCDAModal extends React.Component {
	constructor(props) {
		super(props);

		this.bodyRef = createRef();

		this.xsltProcessor = new XSLTProcessor();
		const parser = new DOMParser();
		const doc = parser.parseFromString(cdaXsl, 'application/xml');

		// Finally import the .xsl
		this.xsltProcessor.importStylesheet(doc);
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.isOpen && this.props.isOpen) {
			if (this.props.ccda && !this.props.dischargeSummary) {
				setTimeout(() => {
					if (this.bodyRef.current) {
						const xmlRef = ( new window.DOMParser() ).parseFromString(this.props.ccda, 'text/xml');
						const fragment = this.xsltProcessor.transformToFragment(xmlRef, document);
						this.bodyRef.current.appendChild(fragment);
					}
				}, 100);
			}
		}
	}

	render() {
		const { isOpen, onClose, dischargeSummary } = this.props;

		return (
			<Modal isOpen={isOpen} contentLabel="CCDA" className="modal-dialog modal-lg ccda-modal">
				<div className="modal-content">
					<div className="modal-header">
						<div className="clearfix">
							<div className="pull-right">
								<button className="btn btn-link" onClick={onClose}>
									<em className="fa fa-lg fa-times" />
								</button>
							</div>
							<h3 className="modal-title">
								{dischargeSummary ? (
									'Discharge Summary'
								): (
									'CCDA'
								)}
							</h3>
						</div>
					</div>
					<div className="modal-body" ref={this.bodyRef}>
						{dischargeSummary && (
							<div className="iframe-wrapper">
								<iframe
									srcDoc={dischargeSummary}
									width="100%"
								/>
							</div>
						)}
					</div>
					<div className="modal-footer">
						<div className="pull-right">
							<Button
								title="Close"
								onClick={onClose}
								large
								primary
								className="ml"
							/>
						</div>
					</div>
				</div>
			</Modal>
		);
	}
}

CCDAModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func.isRequired,
	ccda: PropTypes.string,
	dischargeSummary: PropTypes.string,
};

export default CCDAModal;
